/*
 * Copyright (c) 2022 E-WIND - Thais Watanabe.
 * All rights reserved.
 */
import React, { useEffect, useState } from "react";
import moment from "moment";
import { Image } from "@aws-amplify/ui-react";
import { Storage } from "aws-amplify";

import { queryPhotos } from "src/services/AmplifyQuery";

import ResultDropdown from "src/components/dropdowns/Result.react";

import { Table, TableBody, Col } from "src/components/tables/Table.react";

import Card from "src/components/cards/Card.react";
import LoadingCard from "src/components/loading/LoadingCard.react";
import PrintHeader from "src/components/print/PrintHeader.react";

/**
 * The Converter Page component
 *
 * @author Thais Watanabe
 */
const Converter = (props) => {
  const {
    turbineInspection,
    inspectionModel,
    inspectionModelItems,
    lastTurbineInspections,
    openEdit,
    openObs,
    inspection,
  } = props;

  const [photos, setPhotos] = useState(null);
  const [photosURL, setPhotosURL] = useState(null);

  const models = inspectionModelItems.filter((obj) =>
    ["6-2", "6-3", "6-4"].includes(obj.name)
  );

  /* useEffect */
  useEffect(() => {
    fetchPhotos();

    return () => {
      setPhotos([]);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /**
   * fetchPhotos
   */
  async function fetchPhotos() {
    /* eslint-disable no-dupe-keys */
    const filter = {
      or: [
        {
          modelItemName: { beginsWith: "6-2" },
          modelItemName: { beginsWith: "6-3" },
          modelItemName: { beginsWith: "6-4" },
        },
      ],
      turbineInspectionID: { eq: turbineInspection.id },
    };

    queryPhotos(filter, null, [], setPhotos);
  }

  useEffect(() => {
    async function fetchImages() {
      if (photos) {
        const urls = await Promise.all(
          photos?.map(async (obj) => await Storage.get(obj?.s3Path.slice(7)))
        );
        setPhotosURL(urls);
      }
    }

    fetchImages();
  }, [photos]);

  return (
    <div className="pagebreak">
      <PrintHeader
        inspectionModel={inspectionModel}
        inspection={inspection}
        turbineInspection={turbineInspection}
      />

      {models.map((model, i) => (
        <Card
          key={i}
          title={
            <div className="flex print:hidden">
              <ResultDropdown
                openEdit={openEdit}
                openObs={openObs}
                selectedItem={model}
                turbineInspection={turbineInspection}
                selectedResult={null}
                lastTurbineInspections={lastTurbineInspections}
                inspection={inspection}
              />
              <p className="ml-5">
                {model.name} {model.description}
              </p>
            </div>
          }
        >
          {!photos ? (
            <LoadingCard />
          ) : (
            <Table className="text-center print:border-black">
              <TableBody>
                {photos
                  .filter((obj) => obj.modelItemName.startsWith(model.name))
                  .sort((a, b) => (a.createdAt > b.createdAt ? 1 : -1))
                  .map((photo, i) => (
                    <tr key={i}>
                      <Col>
                        <Image src={photosURL?.[i]} />
                      </Col>
                      <Col>
                        <p>
                          {photo.modelItemName.split("-")[2] === "1"
                            ? "マスター"
                            : "スレーブ"}
                        </p>
                        <p>{photo.caption}</p>
                        <p>
                          {moment(photo.createdAt).format("YYYY-MM-DD hh:mm")}
                        </p>
                      </Col>
                    </tr>
                  ))}
              </TableBody>
            </Table>
          )}
        </Card>
      ))}
    </div>
  );
};

export default Converter;
